document.addEventListener( 'DOMContentLoaded', function () {
  const speakerSections = document.querySelectorAll( '.speakers .speakers__items' );

  speakerSections.forEach( section => {
    const showMoreBtn = section.querySelector( '.load-more__show-more-wrap .button--outline' );
    const allSpeakers = section.querySelectorAll( '.speakers__items-wrap--item' );
    const seenCountEl = section.querySelector( '.load-more-seen-count' );
    const progressBarEl = section.querySelector( '.load-more__progress-bar' );
    const loadMoreBar = section.querySelector( '.load-more' );

    if (!allSpeakers.length) return;

    function getVisibleCount() {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 480) return 4;
      if (screenWidth <= 768) return 3;
      if (screenWidth <= 880) return 6;
      if (screenWidth <= 1024) return 8;
      return 8;
    }

    function initSpeakersView() {
      const initialVisible = getVisibleCount();

      if (allSpeakers.length <= initialVisible) {
        loadMoreBar.style.display = 'none';
      }

      allSpeakers.forEach( (el, index) => {
        if (index >= initialVisible) {
          el.classList.add( 'speaker-hidden' );
        } else {
          el.classList.remove( 'speaker-hidden' );
        }
      } );

      updateProgress();
      if (section.querySelectorAll( '.speaker-hidden' ).length === 0 && showMoreBtn) {
        showMoreBtn.classList.add( 'speaker-button--hidden' );
      } else if (showMoreBtn) {
        showMoreBtn.classList.remove( 'speaker-button--hidden' );
      }
    }

    function updateProgress() {
      const total = allSpeakers.length;
      const visible = total - section.querySelectorAll( '.speaker-hidden' ).length;
      if (seenCountEl) seenCountEl.textContent = visible;
      if (progressBarEl) progressBarEl.style.width = (visible / total * 100) + '%';
    }

    initSpeakersView();

    if (showMoreBtn) {
      showMoreBtn.addEventListener( 'click', function () {
        const hiddenSpeakers = section.querySelectorAll( '.speaker-hidden' );
        const numberToShow = getVisibleCount() / 2;

        hiddenSpeakers.forEach( (el, index) => {
          if (index < numberToShow) {
            el.classList.remove( 'speaker-hidden' );
          }
        } );

        updateProgress();

        if (section.querySelectorAll( '.speaker-hidden' ).length === 0) {
          showMoreBtn.classList.add( 'speaker-button--hidden' );
        }
      } );
    }

    window.addEventListener( 'resize', () => {
      initSpeakersView();
    } );
  } );
} );
